import axiosInstance from "./axios/axios_instance"
const http = axiosInstance("/public",  null, "/forbidden")

const getOrganisationRoles = () => http.get("/organisation_roles");

export default {
    getOrganisationRoles
}